// extracted by mini-css-extract-plugin
export default {"container":"SuccessDownloaded_container__aaF7+","label":"SuccessDownloaded_label__QqC+M","subtitle":"SuccessDownloaded_subtitle__8K45V"};